import {
    Build as BuildIcon,
    Check as CheckIcon,
    FiberManualRecord as CircleIcon,
    Remove as RemoveIcon
} from "@mui/icons-material";
import React from "react";
import {Box} from "@mui/material";

const statuses = {
    notStarted: {
        icon: <RemoveIcon/>,
        bgColor: '#DDE3EA',
        iconColor: '#FE6F5C',
    },
    inProgress: {
        icon: <BuildIcon/>,
        bgColor: '#1293FE',
        iconColor: '#ffffff',
    },
    completed: {
        icon: <CheckIcon/>,
        bgColor: '#77DBA4',
        iconColor: '#ffffff',
    }
};

export default function ProgressIconComponent({data: {not_started, finished, late, over_year_late, status}, fontSize = 16, hideDelays}: {data: any, fontSize?: number, hideDelays: any;}) {
    // const total = not_started + finished + late + over_year_late;
    // const status = not_started === total ? statuses.notStarted : finished === total ? statuses.completed : statuses.inProgress;
    const iconStatus = status === 1 ? statuses.notStarted : status === 2 ? statuses.inProgress : statuses.completed;
    const severityColor = hideDelays ? '#FFF' : over_year_late > 0 ? '#FE776A' : late > 0 ? '#F6C24B' : '#FFF';
    return (
        <Box aria-label={status === 1 ? 'טרם החל' : status === 2 ? 'בתהליך' : 'הסתיים'} sx={{
            width: (fontSize * 2),
            height: (fontSize * 2),
            borderRadius: '50%',
            bgcolor: iconStatus.bgColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {iconStatus.icon && React.cloneElement(iconStatus.icon, {
                sx: { width: fontSize, height: fontSize, color: severityColor },
            })}
        </Box>
    )
}